<!-- Mobile, header -->
<div class="d-block d-md-none"></div>
<!-- Desktop, with header  -->
<div class="d-none d-md-block">
    <div class="row mt-n1" *ngIf="vm.rows.length > 0">
        <!-- left side -->
        <div class="col-md-4 mb-0">
            <!-- Search form -->
            <div class="form-inline md-form form-sm my-0" *ngIf="showSearchInput">
                <mdb-icon fas icon="search" aria-hidden="true"></mdb-icon>
                <input class="form-control form-control-sm ml-2 w-75" type="search" [ngModel]="vm.searchValue"
                    (ngModelChange)="doDataSearch(vm, $event)" placeholder="Search text">
            </div>
        </div>
        <!-- right side -->
        <div class="col-md-2 mt-1">
            <div *ngIf="workingText">
                <span>{{workingText}}</span>
            </div>
        </div>
        <div class="col-md-6 mr-0">
        </div>
    </div>
    <div class="row mt-2">
        <span *ngIf="!vm.rowsFiltered.length" class="ml-3 text-info">No data found at the moment!</span>
        <table *ngIf="vm.rowsFiltered.length" mdbTable mdbTableScroll striped="true" bordered="true" small="true"
            style="table-layout: fixed;" maxHeight="{{tableMaxHeight}}" scrollY="true" fixedHeader="true"
            class="table-responsive">
            <thead>
                <tr>
                    <th scope="col" *ngFor="let c of vm.columns; index as i" style="font-size: small;"
                        [ngClass]="setColumnStyle(c)" (click)="sortColumnClicked(vm.columns, i, vm.rowsFiltered);">
                        {{c.name | titlecase }}
                        <mdb-icon style="color:blue;"  *ngIf="c.sortDirection==='up'" fas icon="arrow-down"></mdb-icon>
                        <mdb-icon style="color:blue;"  *ngIf="c.sortDirection==='down'" fas icon="arrow-up"></mdb-icon>
                        <mdb-icon style="color:black;"  *ngIf="!c.sortDirection || !c.sortDirection.length" fas icon="sort"></mdb-icon>
                    </th>
                </tr>
                <ng-container *ngIf="showTotalsOnTop && vm.totalsFiltered && vm.totalsFiltered.length">
                    <tr *ngFor="let t of vm.totalsFiltered">
                        <th *ngFor="let r of t.rows" style="font-size: small;" [ngClass]="setTotalsStyle(r)">
                            <ng-container *ngFor="let cr of r.cellRows; index as cri">
                                <span *ngIf="cr.title && cr.title.data.length"
                                    [ngClass]="setCellRowTitleStyle(cr, '', -1)">{{cr.title.data}}</span>
                                <span [ngClass]="setCellRowStyle(cr, '', -1)">{{cr.data}}</span>
                                <br *ngIf="r.cellRows.length > 1 && cri < r.cellRows.length-1" />
                            </ng-container>
                        </th>
                    </tr>
                </ng-container>
            </thead>
            <tbody>
                <tr mdbTableCol *ngFor="let r of vm.rowsFiltered.slice(0,100); index as i">
                    <td *ngFor="let c of r.cells; index as ci" style="font-size: small;" [ngClass]="setCellStyle(c)"
                        [title]="setToolTip(c, ci)">
                        <div *ngFor="let cr of c.cellRows; index as cri">
                            <div class="row">
                                <div class="col-md-12 mr-0" *ngIf="cr.title && cr.title.data.length">
                                    <div class="row">
                                        <div [ngClass]="setCellRowTitleStyle(cr, 'col-md-8', cri)" [title]="setTitleToolTip(cr.title, cri)">
                                            {{cr.title.data}}
                                        </div>
                                        <div [ngClass]="setCellRowStyle(cr, 'col-md-4', cri)" [title]="setCellRowToolTip(cr)">
                                            {{cr.data}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 mr-0" *ngIf="!cr.title || !cr.title.data.length">
                                    <div class="col-md-12 mr-0" *ngIf="showLink && ci === keyIndex && cri === 0">
                                        <div class="row">
                                            <div class="col-md-2 text-left">
                                                <a class="text-info" (click)="showDetailsPanel(cr.data)"><i class="fas fa-eye"></i></a>
                                            </div>
                                            <div [ngClass]="setCellRowStyle(cr, 'col-md-10', -1)">{{cr.data}}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mr-0" *ngIf="!showLink || ci !== keyIndex || cri !== 0">
                                        <div class="row">
                                            <div [ngClass]="setCellRowStyle(cr, '', -1)" [title]="setCellRowToolTip(cr)">{{cr.data}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <ng-container *ngIf="!showTotalsOnTop && vm.totalsFiltered && vm.totalsFiltered.length">
                    <tr *ngFor="let t of vm.totalsFiltered">
                        <th *ngFor="let r of t.rows" style="font-size: small;" [ngClass]="setTotalsStyle(r)">
                            <ng-container *ngFor="let cr of r.cellRows; index as cri">
                                <span *ngIf="cr.title && cr.title.data.length"
                                    [ngClass]="setCellRowTitleStyle(cr, '', -1)">{{cr.title.data}}</span>
                                <span [ngClass]="setCellRowStyle(cr, '', -1)">{{cr.data}}&nbsp;&nbsp;</span>
                                <br *ngIf="r.cellRows.length > 1 && cri < r.cellRows.length-1" />
                            </ng-container>
                        </th>
                    </tr>
                </ng-container>
            </tfoot>
        </table>
    </div>
</div>